// Schematic SVG generator

import React from "react";


function SchematicSVG({
	width,height,//if forced, else, fully automatic based on the scale factor
	color,//schematic / text color
	contrast_color,//a stroke color to enhance readability
	scale,//px per meter
	mode,//mode, are we setting depth, height, width?
	w,h,d,slope
}) {

	width = width||'auto';
	height = height||'auto';
	let total_width = 0;
	let total_height = 0;
	mode = mode||'depth';
	slope = slope||Math.atan(0.1);//rad of the roof
	scale = scale||17;//px per meter
	const thickness = (scale>15)?4:3;//px thickness of the columns
	color = color||'#555555';
	contrast_color = contrast_color||'#ffffff';
	const text_size = (scale>15)?28:18;//px
	const arrow_thickness = 1;//px
	const arrow_margin = 1;//px

	w = w||4;//meters
	h = h||3;//meters
	d = d||4;//meters


	// Define the contour
	if(mode==='width'){
		slope = 0;
	}
	const slope_tan = Math.tan(slope);
	const slope_cos = Math.cos(slope);
	const contour_w = (mode==='width')?w:d;
	const contour = [
		[0,Math.round(h*scale)],
		[0,0],
		[Math.round(contour_w*scale),Math.round(contour_w*scale)*slope_tan],
		[Math.round(contour_w*scale),Math.round(h*scale)]
	];
	const contour_width = contour[2][0];
	const contour_height = contour[0][1];
	// Create the thickness
	const thickness_contour = [
		[thickness,contour[0][1]],
		[thickness,thickness*slope_tan+thickness/slope_cos],
		[contour[2][0]-thickness,(contour[2][0]-thickness)*slope_tan+thickness/slope_cos],
		[contour[3][0]-thickness,contour[3][1]]
	];
	const contour_points = [].concat(contour,thickness_contour.reverse()).map(arr=>((arr[0])+','+(arr[1]))).join(' ');


	// Define the text
	let text = w,secondary_text;
	if(mode==='height'){
		text = h;
	}else if(mode==='depth'){
		text = d;
	}
	const arrow_width = Math.round(text*scale);
	if(Number.isInteger(text)){
		secondary_text = ' m';
	}else{
		secondary_text = text-Math.floor(text);
		text = Math.floor(text);
		secondary_text = '.'+('00'+Math.round(secondary_text*100)).slice(-2);
	}
	const text_html = <>{text}<tspan fontWeight="600" letterSpacing={-0.5} fontSize={Math.round(text_size/1.75)}>{secondary_text}</tspan></>;


	// Define the arrow
	const [
		arrow_x0,arrow_x1,arrow_x2,arrow_x3,
		arrow_ytop,arrow_ytopline,arrow_middle,arrow_ybottomline,arrow_ybottom
	] = [
		0,arrow_thickness*4,arrow_width-arrow_thickness*4,arrow_width,
		arrow_thickness*3,arrow_thickness*2,arrow_thickness*1.5,arrow_thickness*1,0
	]
	const arrow_points = [
		[arrow_x0,arrow_middle],
		[arrow_x1,arrow_ytop],
		[arrow_x1,arrow_ytopline],
		[arrow_x2,arrow_ytopline],
		[arrow_x2,arrow_ytop],
		[arrow_x3,arrow_middle],
		[arrow_x2,arrow_ybottom],
		[arrow_x2,arrow_ybottomline],
		[arrow_x1,arrow_ybottomline],
		[arrow_x1,arrow_ybottom]
	].map(arr=>((arr[0])+','+(arr[1]))).join(' ');
	const arrow_height = arrow_ytop;


	// Arrow and text position
	let g_arrow_and_text_transform,contour_shift = 0;
	const height_compressor = text_size/4;//px, to ajust the svg to perfection
	if(mode==='height'){
		total_width = text_size + arrow_margin + arrow_height + arrow_margin + contour_width - height_compressor;
		total_height = contour_height;
		g_arrow_and_text_transform = 'rotate(-90) translate('+(-arrow_width)+' '+(text_size-height_compressor)+')';
		contour_shift = text_size + arrow_margin + arrow_height + arrow_margin - height_compressor;
	}else{
		total_width = contour_width;
		total_height = contour_height + arrow_margin + arrow_height;
		g_arrow_and_text_transform = 'translate(0 '+contour_height+')';
	}
	const g_arrow_and_text = <g transform={g_arrow_and_text_transform}>
		<text fontWeight="500" stroke={contrast_color} strokeWidth="3px" x={arrow_width/2} y="-1" textAnchor="middle" fontSize={text_size}>{text_html}</text>
		<text fontWeight="500" fill={color} x={arrow_width/2} y="-1" textAnchor="middle" fontSize={text_size}>{text_html}</text>
		<polygon transform={'translate(0 '+arrow_margin+')'} fill={color} points={arrow_points} />
	</g>



	if(height==='auto'){
		height = total_height;
	}
	if(width==='auto'){
		width = total_width;
	}

	return (
		<svg width={width} height={height}>
			<g transform={'translate('+Math.floor((width-total_width)/2)+' '+((height-total_height)/((mode==='height')?1:2))+')'}>
				<polygon transform={'translate('+contour_shift+' 0)'} fill={color} points={contour_points} />
				{g_arrow_and_text}
			</g>
		</svg>
	);
}

export default React.memo(SchematicSVG);
